import * as React from 'react';
import { ToneRowComponent, ToneRowOptionsPrivilage, ToneRowOptionsPrivilageImpl } from './tonerowcomponent';
import { ToneDto } from '../../../../core/dto/tonedto';
import { PaginationListViewModelImpl } from '../../verticallist/paginationverticallist/paginationlistviewmodel';
import { EnglishToneRowCSSStyle, EnglishToneRowCSSStyleImpl } from './englishtonerowcss';
import { BaseContext } from '../../../../utils/basecontext';

export class ToneRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setTellAFriend(true);
        this.setAddWishList(true);
        this.setPlay(true);
        this.setSettings(true);
        this.setAction(true);
    }
}

export class ToneViewModelImpl extends PaginationListViewModelImpl<ToneDto>
{
    private cssStyle: EnglishToneRowCSSStyle;
    private privilage: ToneRowOptionsPrivilage;

    constructor(offset: number, context: BaseContext)
    {
        super(offset, context);

        this.cssStyle =  new EnglishToneRowCSSStyleImpl(context);

        this.privilage = new ToneRowOptionsImpl();
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        return <ToneRowComponent onTuneSettingsAdded={() =>{}} onDeleteClicked={(toneDto: ToneDto) =>{this.deleteData(toneDto.getId());}} toneRowOptionsPrivilage={this.privilage} cssStyle={this.cssStyle} key={position}  context={this.getContext()} toneDto={t}  position={position}/>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/toneoptions/tone/toneviewmodel.tsx